import { TGetOrdersQuery } from '../helpers';
import {
  IGetOrdersListDTO,
  OrderPaymentChannel,
  OrdersDeliveryType,
  OrdersPaymentStatus,
  OrdersSortDirection,
  OrdersStatus,
  PartnerConfirmationStatus,
} from '@/models/orders.model';

class GetOrdersListDTO implements IGetOrdersListDTO {
  number?: number;
  date_from?: string;
  date_to?: string;
  payment_date_from?: string;
  payment_date_to?: string;
  contact_name?: string;
  contact_phone?: string;
  status?: OrdersStatus;
  payment_status?: OrdersPaymentStatus;
  payment_channel?: OrderPaymentChannel;
  delivery_type?: OrdersDeliveryType;
  sort_direction?: OrdersSortDirection;
  page?: number;
  manager_id?: string;
  utm_source?: string;
  partner_confirmation_status?: PartnerConfirmationStatus;

  constructor({
    number,
    date_from,
    date_to,
    payment_date_from,
    payment_date_to,
    contact_name,
    contact_phone,
    delivery_type,
    status,
    payment_status,
    payment_channel,
    page,
    sort_direction,
    manager_id,
    utm_source,
    partner_confirmation_status,
  }: TGetOrdersQuery) {
    this.number = number;
    this.date_from = date_from;
    this.date_to = date_to;
    this.payment_date_from = payment_date_from;
    this.payment_date_to = payment_date_to;
    this.contact_name = contact_name;
    this.contact_phone = contact_phone;
    this.delivery_type = delivery_type;
    this.status = status;
    this.payment_status = payment_status;
    this.payment_channel = payment_channel;
    this.sort_direction = sort_direction;
    this.page = page;
    this.manager_id = manager_id;
    this.utm_source = utm_source;
    this.partner_confirmation_status = partner_confirmation_status;
  }
}

export default GetOrdersListDTO;
